import { useSite } from '../context/SiteContext';
import { toBn } from '../lib/utils';
import { taka } from '../lib/price';
import { Logo } from './Navbar';
import { ArrowRightIcon, FacebookIcon, WhatsAppIcon } from './Icons';

export function FinalCTA() {
  const { course } = useSite();
  if (!course.enrollmentOpen) return null;

  return (
    <section className="py-20">
      <div className="container-x">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-word-500 to-excel-500 px-6 py-14 text-center text-white sm:px-12">
          <div className="pointer-events-none absolute -left-10 -top-10 h-40 w-40 rounded-full bg-white/10" />
          <div className="pointer-events-none absolute -bottom-16 -right-10 h-56 w-56 rounded-full bg-white/10" />
          <div className="relative">
            <h2 className="text-3xl font-bold leading-tight sm:text-4xl">আজ শুরু করলে {toBn(course.windowDays)} দিন পর আপনি অন্য মানুষ</h2>
            <p className="mx-auto mt-4 max-w-2xl text-lg text-white/90">
              যে দক্ষতা সারাজীবন কাজে লাগবে{course.price != null && `, তার জন্য মাত্র ${taka(course.price)}`}। সিট শেষ হওয়ার আগেই নিশ্চিত করুন।
            </p>
            <a href="#enroll" className="mt-8 inline-flex items-center gap-2 rounded-xl bg-white px-8 py-4 text-lg font-bold text-word-600 shadow-xl transition hover:-translate-y-0.5">
              এখনই ভর্তি হোন <ArrowRightIcon className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Footer() {
  const { course } = useSite();
  const { contact } = course;
  return (
    <footer className="bg-slate-900 pb-24 pt-12 text-slate-400 md:pb-12">
      <div className="container-x flex flex-col items-center justify-between gap-6 md:flex-row">
        <div className="text-center md:text-left">
          <Logo light />
          <p className="mt-3 text-sm">শিক্ষার্থী ও অফিস কর্মীদের জন্য প্র্যাকটিক্যাল MS Excel প্রশিক্ষণ · ঢাকা</p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
          {contact.phone && <a href={`tel:${contact.phone}`} className="hover:text-white">📞 {contact.phone}</a>}
          {contact.email && <a href={`mailto:${contact.email}`} className="hover:text-white">✉️ {contact.email}</a>}
          {contact.whatsapp && (
            <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noreferrer" className="rounded-full bg-white/10 p-2.5 hover:bg-[#25D366] hover:text-white" aria-label="WhatsApp">
              <WhatsAppIcon className="h-5 w-5" />
            </a>
          )}
          {contact.facebook && (
            <a href={contact.facebook} target="_blank" rel="noreferrer" className="rounded-full bg-white/10 p-2.5 hover:bg-[#1877F2] hover:text-white" aria-label="Facebook">
              <FacebookIcon className="h-5 w-5" />
            </a>
          )}
        </div>
      </div>
      <div className="container-x mt-8 border-t border-white/10 pt-6 text-center text-sm">
        © {toBn(new Date().getFullYear())} {course.brand}. সর্বস্বত্ব সংরক্ষিত।
      </div>
    </footer>
  );
}
